import React, { useMemo } from 'react'

import { ExposeCoordinatesView } from 'common/builder/components/chart/FlowChart/components/ExposeCoordinatesView/ExposeCoordinatesView'
import { NextStep } from 'common/builder/components/chart/FlowChart/components/NextStep/NextStep'
import { useButtonCtrLabel } from 'common/builder/components/chart/FlowChart/hooks/useButtonCtrLabel'
import { useButtonName } from 'common/builder/components/chart/FlowChart/hooks/useButtonName'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

import * as styles from './QuickReplyButton.styles'

interface QuickReplyButtonProps {
  button: FlowChartButton
  style?: React.CSSProperties
}

export const QuickReplyButton = ({ button, style }: QuickReplyButtonProps) => {
  const buttonName = useButtonName(button)
  const ctrLabel = useButtonCtrLabel(button)

  const wrapperStyle = useMemo(() => ({ ...styles.ButtonWrapper, ...style }), [style])

  return (
    <ExposeCoordinatesView
      name={buttonName}
      id={button.id}
      style={wrapperStyle}
      interactive={button.isInteractive}
    >
      <richtext style={styles.ButtonText} text={button.caption} />
      {ctrLabel && <richtext style={styles.CtrText} text={ctrLabel} />}
      {button.nextStep && (
        <view style={styles.NextStepWrapper}>
          <NextStep nextStep={button.nextStep} />
        </view>
      )}
    </ExposeCoordinatesView>
  )
}
